// Vendai Digital Pay (PERSONAL) API client — VendaiDigitalPaySwagger.txt ile birebir.
//
// Notlar:
// - Yollar Swagger'daki gibi yazılır (/api/Personal). Proje kodu önekini
//   (/PERSONAL) axiosInterceptor ekler — Swagger'da görünmez ama gerçek
//   istekte vardır. Repodaki diğer API dosyalarıyla aynı davranış.
// - Cevap zarfını (LettaResult) da axiosInterceptor açar: returnCode === 0 ise
//   `data` döner, değilse `exMessage` ile Error fırlatır. Burada açmıyoruz.
// - Alan ve yol adları Swagger'daki gibi, yazım hataları dahil (Ballance, HealthChek).

import axiosInstance from "../config/axiosInterceptor";

// Liste uçları veri yoksa null dönebilir; grid'ler her zaman dizi bekliyor.
const asList = (data) => (Array.isArray(data) ? data : []);

/**
 * Swagger'daki altı varlık da aynı CRUD şekline sahip:
 *   GET /api/X · GET /api/X/{id} · POST /api/X · PUT /api/X · DELETE /api/X/{id}
 */
function crud(resource) {
  const base = `/api/${resource}`;
  return {
    list: () => axiosInstance.get(base).then(asList),
    getById: (id) => axiosInstance.get(`${base}/${id}`),
    create: (dto) => axiosInstance.post(base, dto),
    update: (dto) => axiosInstance.put(base, dto),
    remove: (id) => axiosInstance.delete(`${base}/${id}`),
  };
}

const authCompany = crud("AuthCompany");
const firm = crud("Firm");
const department = crud("Department");
const personal = crud("Personal");
const limitDefinition = crud("LimitDefinition");
const transaction = crud("Transaction");

// --- AuthCompany ---
export const getAuthCompanies = authCompany.list;
export const getAuthCompanyById = authCompany.getById;
export const createAuthCompany = authCompany.create;
export const updateAuthCompany = authCompany.update;
export const deleteAuthCompany = authCompany.remove;

// --- Firm ---
export const getFirms = firm.list;
export const getFirmById = firm.getById;
export const createFirm = firm.create;
export const updateFirm = firm.update;
export const deleteFirm = firm.remove;

// --- Department ---
export const getDepartments = department.list;
export const getDepartmentById = department.getById;
export const createDepartment = department.create;
export const updateDepartment = department.update;
export const deleteDepartment = department.remove;

// --- Personal ---
export const getPersonal = personal.list;
export const getPersonalById = personal.getById;
export const createPersonal = personal.create;
export const updatePersonal = personal.update;
export const deletePersonal = personal.remove;

// --- LimitDefinition ---
export const getLimitDefinitions = limitDefinition.list;
export const getLimitDefinitionById = limitDefinition.getById;
export const createLimitDefinition = limitDefinition.create;
export const updateLimitDefinition = limitDefinition.update;
export const deleteLimitDefinition = limitDefinition.remove;

// --- Transaction ---
// Ekranda salt okunur kullanılıyor; yazma uçları Swagger'da var ama bilerek
// dışa açılmıyor — işlem geçmişi elle değiştirilmemeli.
export const getTransactions = transaction.list;
export const getTransactionById = transaction.getById;

// --- Payment ---

/** GET /api/Payment/GetCardBallance/{cardNo}/{firmName} -> BallanceResponseModel */
export function getCardBallance(cardNo, firmName) {
  return axiosInstance.get(
    `/api/Payment/GetCardBallance/${encodeURIComponent(cardNo)}/${encodeURIComponent(firmName)}`
  );
}

/** POST /api/Payment/LoadCardBallance -> LettaWalletPayResponse */
export function loadCardBallance(ballanceLoadRequestModel) {
  return axiosInstance.post("/api/Payment/LoadCardBallance", ballanceLoadRequestModel);
}

/** POST /api/Payment -> LettaWalletPayResponse (harcama; otomat tarafı kullanır) */
export function pay(paymentRequestModel) {
  return axiosInstance.post("/api/Payment", paymentRequestModel);
}

/** GET /api/HealthChek (Swagger'daki yazım korunuyor) */
export function healthCheck() {
  return axiosInstance.get("/api/HealthChek");
}
